import React from 'react'
import { Link } from 'react-router-dom'

const AuthHeader = () => {
  return (
    <header className="bg-[#141414]  px-6  !mb-2">
      <div className="flex items-center justify-between">
        {/* Logo and Title */}
        <div className="flex items-center gap-3 !pl-4">
          {/* TLP Helmet Logo */}
          <img 
            src="/TLP Helmet.png" 
            alt="The Launch Pad Logo" 
            className="w-12 h-12 object-contain"
          />
          
          {/* Stacked Text */}
          <div className="text-white">
            <div className="text-sm font-bold tracking-wider font-avenir">THE</div>
            <div className="text-sm font-bold tracking-wider font-avenir">LAUNCH</div>
            <div className="text-sm font-bold tracking-wider font-avenir">PAD</div>
          </div>
        </div>

        {/* Sign In Link */}
        <Link 
          to="/login" 
          className="text-white hover:text-red-400 transition-colors font-medium text-sm tracking-wider font-avenir text-center p-4" 
        >
          <div className="text-sm font-bold tracking-wider font-avenir">SIGN</div>
          <div className="text-sm font-bold tracking-wider font-avenir">IN</div>
        </Link>
      </div>
    </header>
  )
}

export default AuthHeader
